/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiNote,
    ApiNoteFromJSON,
    ApiNoteToJSON,
    ApiNoteType,
    ApiNoteTypeFromJSON,
    ApiNoteTypeToJSON,
    InternalApiAlertType,
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeToJSON,
    InternalApiCreateNote,
    InternalApiCreateNoteFromJSON,
    InternalApiCreateNoteToJSON,
    InternalApiSortDirection,
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionToJSON,
    NotesPage,
    NotesPageFromJSON,
    NotesPageToJSON,
} from '../models';

export interface AddNoteRequest {
    personId: string;
    apiNote: ApiNote;
}

export interface AddSanctionNoteRequest {
    sanctionAlertId: number;
    apiNote: ApiNote;
}

export interface CreateNoteRequest {
    internalApiCreateNote: InternalApiCreateNote;
}

export interface FindAllAlertNotesRequest {
    page: number;
    size: number;
    alertId: number;
    alertType: InternalApiAlertType;
    query?: string;
    orderBy?: string;
    direction?: InternalApiSortDirection;
}

export interface FindAllNotesRequest {
    personId: string;
    page: number;
    size: number;
    query?: string;
    orderBy?: string;
    direction?: InternalApiSortDirection;
    type?: ApiNoteType;
}

/**
 * 
 */
export class NoteInternalApi extends runtime.BaseAPI {

    /**
     * Creates new note
     */
    async addNoteRaw(requestParameters: AddNoteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiNote>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling addNote.');
        }

        if (requestParameters.apiNote === null || requestParameters.apiNote === undefined) {
            throw new runtime.RequiredError('apiNote','Required parameter requestParameters.apiNote was null or undefined when calling addNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/notes`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiNoteToJSON(requestParameters.apiNote),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiNoteFromJSON(jsonValue));
    }

    /**
     * Creates new note
     */
    async addNote(requestParameters: AddNoteRequest, initOverrides?: RequestInit): Promise<ApiNote> {
        const response = await this.addNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates new note
     */
    async addSanctionNoteRaw(requestParameters: AddSanctionNoteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiNote>> {
        if (requestParameters.sanctionAlertId === null || requestParameters.sanctionAlertId === undefined) {
            throw new runtime.RequiredError('sanctionAlertId','Required parameter requestParameters.sanctionAlertId was null or undefined when calling addSanctionNote.');
        }

        if (requestParameters.apiNote === null || requestParameters.apiNote === undefined) {
            throw new runtime.RequiredError('apiNote','Required parameter requestParameters.apiNote was null or undefined when calling addSanctionNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/sanctions/alerts/{sanctionAlertId}/notes`.replace(`{${"sanctionAlertId"}}`, encodeURIComponent(String(requestParameters.sanctionAlertId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiNoteToJSON(requestParameters.apiNote),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiNoteFromJSON(jsonValue));
    }

    /**
     * Creates new note
     */
    async addSanctionNote(requestParameters: AddSanctionNoteRequest, initOverrides?: RequestInit): Promise<ApiNote> {
        const response = await this.addSanctionNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create note for alert
     */
    async createNoteRaw(requestParameters: CreateNoteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiNote>> {
        if (requestParameters.internalApiCreateNote === null || requestParameters.internalApiCreateNote === undefined) {
            throw new runtime.RequiredError('internalApiCreateNote','Required parameter requestParameters.internalApiCreateNote was null or undefined when calling createNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/notes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCreateNoteToJSON(requestParameters.internalApiCreateNote),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiNoteFromJSON(jsonValue));
    }

    /**
     * Create note for alert
     */
    async createNote(requestParameters: CreateNoteRequest, initOverrides?: RequestInit): Promise<ApiNote> {
        const response = await this.createNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Page is ignored, returns ALL notes for selected alert
     * Fetches all notes
     */
    async findAllAlertNotesRaw(requestParameters: FindAllAlertNotesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NotesPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllAlertNotes.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllAlertNotes.');
        }

        if (requestParameters.alertId === null || requestParameters.alertId === undefined) {
            throw new runtime.RequiredError('alertId','Required parameter requestParameters.alertId was null or undefined when calling findAllAlertNotes.');
        }

        if (requestParameters.alertType === null || requestParameters.alertType === undefined) {
            throw new runtime.RequiredError('alertType','Required parameter requestParameters.alertType was null or undefined when calling findAllAlertNotes.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        if (requestParameters.alertId !== undefined) {
            queryParameters['alertId'] = requestParameters.alertId;
        }

        if (requestParameters.alertType !== undefined) {
            queryParameters['alertType'] = requestParameters.alertType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/notes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotesPageFromJSON(jsonValue));
    }

    /**
     * Page is ignored, returns ALL notes for selected alert
     * Fetches all notes
     */
    async findAllAlertNotes(requestParameters: FindAllAlertNotesRequest, initOverrides?: RequestInit): Promise<NotesPage> {
        const response = await this.findAllAlertNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches all notes
     */
    async findAllNotesRaw(requestParameters: FindAllNotesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NotesPage>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling findAllNotes.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllNotes.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllNotes.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/notes`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotesPageFromJSON(jsonValue));
    }

    /**
     * Fetches all notes
     */
    async findAllNotes(requestParameters: FindAllNotesRequest, initOverrides?: RequestInit): Promise<NotesPage> {
        const response = await this.findAllNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
